// extracted by mini-css-extract-plugin
export default {"pageHeader":"ProductsHeader_pageHeader__cDeFh","grainsImage":"ProductsHeader_grainsImage__s80y2"};